//kpis
import { liveMentions } from '@/lib/listening/charts/instagram/liveMentions';
import { mentionsByPost } from '@/lib/listening/charts/instagram/mentionsByPost';
import { mentionsByType } from '@/lib/listening/charts/instagram/mentionsByType';
//charts
import { mentionsHistory } from '@/lib/listening/charts/instagram/mentionsHistory';
import { totalCaptionsMentions } from '@/lib/listening/kpis/instagram/totalCaptionsMentions';
import { totalCommentsMentions } from '@/lib/listening/kpis/instagram/totalCommentsMentions';
import { totalMentions } from '@/lib/listening/kpis/instagram/totalMentions';
import { totalTagsMentions } from '@/lib/listening/kpis/instagram/totalTagsMentions';
//widget
import { lastMentionedPosts } from '@/lib/listening/widget/instagram/lastMentionedPosts';

export const MentionsInstagram = [
    //  line 1
    totalMentions,
    totalCaptionsMentions,
    totalCommentsMentions,
    totalTagsMentions,
    //  line 2
    lastMentionedPosts,
    //  line 3
    mentionsHistory,
    liveMentions,
    mentionsByType,
    mentionsByPost
];

export const requestInstagramParams = [
    //line 1
    'mentions',
    'mentions_captions',
    'mentions_tags',
    'mentions_comments',
    //line 3
    'mentions_history',
    'mentions_live',
    'mentions_distribution_per_type',
    'mentions_distribution_per_post'
];
